
import { defineComponent } from "vue";
import { uuid } from "vue-uuid";
import { FoodItem, Queuer } from "@/types/Donor";
import SearchingFor from "@/components/Donor/SearchingForCharities.vue";
import DonationQueue from "@/components/Donor/DonationQueue.vue";

export default defineComponent({
  name: "DonateView",
  data() {
    return {
      windowWidth: window.innerWidth,
      queuers: [] as Queuer[],
      foodTypes: [
        "Eggs and Dairy",
        "Fruits",
        "Vegetables",
        "Meat and Poultry",
        "Fish and Seafood",
        "Grains and Nuts",
      ],
      newItem: {
        itemId: uuid.v1(),
        name: "",
        type: "Eggs and Dairy",
        stage: "In Storage",
        quantity: 0,
        weight: 0,
        createdAt: new Date().toString(),
        updatedAt: new Date().toString(),
      } as FoodItem,
      foodItems: [
        {
          itemId: uuid.v1(),
          name: "Chicken Breast",
          type: "Meat and Poultry",
          stage: "In Storage",
          quantity: 2,
          weight: 1,
          createdAt: new Date().toString(),
          updatedAt: new Date().toString(),
        },
        {
          itemId: uuid.v1(),
          name: "Brussels Sprouts",
          type: "Vegetables",
          stage: "Prepared",
          quantity: 1,
          weight: 3,
          createdAt: new Date().toString(),
          updatedAt: new Date().toString(),
        },
        {
          itemId: uuid.v1(),
          name: "Tuna Panga",
          type: "Fish and Seafood",
          stage: "In Storage",
          quantity: 2,
          weight: 0.25,
          createdAt: new Date().toString(),
          updatedAt: new Date().toString(),
        },
        {
          itemId: uuid.v1(),
          name: "Duck Eggs",
          type: "Eggs and Dairy",
          stage: "Prepared",
          quantity: 2,
          weight: 0.2,
          createdAt: new Date().toString(),
          updatedAt: new Date().toString(),
        },
      ] as FoodItem[],
    };
  },
  components: {
    SearchingFor,
    DonationQueue,
  },
  methods: {
    onResize(): void {
      this.windowWidth = window.innerWidth;
    },
    createItem(): void {
      this.foodItems.push(this.newItem as FoodItem);
      this.newItem = Object.assign(
        {},
        {
          itemId: uuid.v1(),
          name: "",
          type: "Eggs and Dairy",
          stage: "In Storage",
          quantity: 0,
          weight: 0,
          createdAt: new Date().toString(),
          updatedAt: new Date().toString(),
        }
      );
    },
    removeItem(index: number): void {
      this.foodItems.splice(index, 1);
    },
    resetForm(): void {
      this.newItem = Object.assign(
        {},
        {
          itemId: uuid.v1(),
          name: "",
          type: "Eggs and Dairy",
          stage: "In Storage",
          quantity: 0,
          weight: 0,
          createdAt: new Date().toString(),
          updatedAt: new Date().toString(),
        }
      );
      this.foodItems = Object.assign([], []);
    },
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.queuers = Object.assign(
      [],
      [
        {
          queuerId: uuid.v1(),
          charityId: uuid.v1(),
          name: "Cebu Food Bank",
          status: "Pending",
          queuePos: 1,
          queueWeight: 1000,
          distance: 1100,
          donationsReceived: 1,
          createdAt: new Date().toString(),
          updatedAt: new Date().toString(),
        },
        {
          queuerId: uuid.v1(),
          charityId: uuid.v1(),
          name: "Hippodromo Barangay Hall",
          status: "Pending",
          queuePos: 2,
          queueWeight: 1100,
          distance: 1300,
          donationsReceived: 2,
          createdAt: new Date().toString(),
          updatedAt: new Date().toString(),
        },
        {
          queuerId: uuid.v1(),
          charityId: uuid.v1(),
          name: "JPIC-IDC Inc.",
          status: "Pending",
          queuePos: 3,
          queueWeight: 1200,
          distance: 1800,
          donationsReceived: 2,
          createdAt: new Date().toString(),
          updatedAt: new Date().toString(),
        },
      ]
    );
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
});
